import adminApiClient from './adminApiClient';

export const adminCompanyService = {
  getAll:  () => adminApiClient.get('/api/companies'),
  getById: (id) => adminApiClient.get(`/api/companies/${id}`),
  update:  (id, data) => adminApiClient.put(`/api/companies/${id}`, data),

  getPaged(search, isActive, page, size) {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (isActive !== null && isActive !== undefined) params.append('isActive', isActive);
    params.append('page', page);
    params.append('size', size);
    return adminApiClient.get(`/api/companies?${params.toString()}`);
  },
};

export default adminCompanyService;
